import {useTranslation} from 'react-i18next';

import {RatingSummary as RatingSummaryUI} from '@/components/RatingSummary';
import {REVIEW_SCORE_AMADEUS_MAX} from '@/consts';
import {useLocalSplit} from '@/modules/common/hooks';
import {mapAmadeusRatingToSentiment} from '@/modules/common/utils/rating';

type Props = React.ComponentProps<'div'> & {
  size?: 'small' | 'medium';
  compact?: boolean;
  ratingScore: number;
  reviewCount: number;
  recommendationRate?: number | null;
  onClickReviewCount?: () => void;
};

export const RatingSummary: React.FunctionComponent<Props> = ({
  size = 'medium',
  compact = false,
  ratingScore,
  reviewCount,
  recommendationRate,
  onClickReviewCount,
  ...restProps
}) => {
  const {t} = useTranslation('hotelDetailsOverlay');
  const recommendationRateTreatment = useLocalSplit(
    'FFP_5186_ama_recommendation_percentage'
  ).treatment;
  const recommendationRateEnabled =
    recommendationRateTreatment === 'on' ||
    recommendationRateTreatment === 'default';

  const ratingSentiment = mapAmadeusRatingToSentiment(ratingScore);
  const ratingLabel = t(
    `hotelDetailsOverlay:amadeusRatingSection.score.categories.${ratingSentiment}`
  );

  return (
    <RatingSummaryUI
      {...restProps}
      size={size}
      compact={compact}
      ratingScore={String(ratingScore.toFixed(1))}
      ratingScoreMax={REVIEW_SCORE_AMADEUS_MAX.toFixed(0)}
      ratingSentiment={ratingSentiment}
      ratingLabel={ratingLabel}
      reviewCount={reviewCount}
      recommendationRate={recommendationRateEnabled ? recommendationRate : null}
      onClickReviewCount={onClickReviewCount}
    />
  );
};
